<div class="forbidden-page">
    <div class="forbidden-card">

        <div class="forbidden-icon">
            <div class="icon-mask" [style.--icon-url]="'url(assets/icons/lock.svg)'"></div>
        </div>

        <h1 class="forbidden-title">You don't have access to this page</h1>
        <p class="forbidden-subtitle">
            Your role doesn't include the permission required to view this page. Contact your administrator if you believe this is a mistake.
        </p>

        <button class="btn-primary" (click)="goHome()">
            Back to home
        </button>

    </div>
</div>
